/* jshint esversion: 6 */
/* jshint ignore:start */
import { useEffect, useContext, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { MyContext } from '../../Context/MyProvider';
import axios from 'axios';
import secureLocalStorage from "react-secure-storage";
import { useTranslation } from 'react-i18next';
import CryptoJS from "crypto-js";
import ImpyImg from "../../image/emptyOrder.png";

const ServiceItemNormal = ({ index, item, ImgBasUrl, Currency, AddCartData, HandleAddCart }) => {

    const { t } = useTranslation();

    const [showdetaisl, setShowDetails] = useState(false);
    const isSelected = AddCartData.includes(item.addon_id);

    return (
        <div onClick={() => HandleAddCart(item, index)} className={`border-[1px] ${isSelected ? "border-[#682afb]" : "border-gray-400"} rounded-[10px] mt-[5px] cursor-pointer`}>
            <div className="flex items-center gap-[10px] px-[10px] py-[5px]">
                <ImgLoad url={ImgBasUrl + item.img} Customestyle={"w-[70px] h-[70px] object-contain"} />
                <div className="">
                    <h1 className="font-[500] text-[17px]">{item.title}</h1>
                    <p className="text-gray-600">{item.subtitle}</p>
                </div>
            </div>
            {showdetaisl && <div className="border-t-[1px] border-b-[1px] py-[5px] border-gray-400 px-[10px]">
                {item.tags.map((item, index) => {
                    return <div key={index} className="flex items-center gap-[5px] mt-[5px]">
                        <div className="bg-gray-200 p-[5px] rounded-[50px]">
                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 1.25C6.072 1.25 1.25 6.072 1.25 12C1.25 17.928 6.072 22.75 12 22.75C17.928 22.75 22.75 17.928 22.75 12C22.75 6.072 17.928 1.25 12 1.25ZM12 21.25C6.899 21.25 2.75 17.101 2.75 12C2.75 6.899 6.899 2.75 12 2.75C17.101 2.75 21.25 6.899 21.25 12C21.25 17.101 17.101 21.25 12 21.25ZM16.6919 12.2871C16.6539 12.3791 16.599 12.462 16.53 12.531L13.53 15.531C13.384 15.677 13.192 15.751 13 15.751C12.808 15.751 12.616 15.678 12.47 15.531C12.177 15.238 12.177 14.763 12.47 14.47L14.1899 12.75H8C7.586 12.75 7.25 12.414 7.25 12C7.25 11.586 7.586 11.25 8 11.25H14.189L12.469 9.53003C12.176 9.23703 12.176 8.76199 12.469 8.46899C12.762 8.17599 13.237 8.17599 13.53 8.46899L16.53 11.469C16.599 11.538 16.6539 11.6209 16.6919 11.7129C16.7679 11.8969 16.7679 12.1031 16.6919 12.2871Z" fill="#25314C" />
                            </svg>
                        </div>
                        <h1 className="text-[15px]">{item}</h1>
                    </div>
                })}
            </div>}
            <div className="flex items-center justify-between px-[10px] py-[5px]">
                <div className="flex items-center gap-[15px]">
                    <button className="flex items-center gap-[10px]">
                        <div className={`border-[2px] border-[#682afb] ${isSelected && "bg-[#682afb]"} rounded-[5px]`}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9 17.75C8.999 17.75 8.99799 17.75 8.99699 17.75C8.79699 17.749 8.60599 17.669 8.46499 17.526L4.46499 13.464C4.17399 13.169 4.178 12.694 4.473 12.403C4.768 12.113 5.24399 12.116 5.53399 12.411L9.003 15.935L18.469 6.46902C18.762 6.17602 19.237 6.17602 19.53 6.46902C19.823 6.76202 19.823 7.23705 19.53 7.53005L9.53 17.5301C9.39 17.6711 9.199 17.75 9 17.75Z" fill="white" />
                            </svg>
                        </div>
                        <h1 className="font-[500] text-[#682afb]">{isSelected ? t("ADDED") : t("ADD")}</h1>
                    </button>
                    <h1 className="font-[500] text-[15px]">{Currency}{item.price}</h1>
                </div>
                <button onClick={(e) => { e.stopPropagation(); setShowDetails(!showdetaisl) }} className="border-[1px] rounded-[50px] border-gray-400">
                    {showdetaisl
                        ? <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16 14.75C15.808 14.75 15.616 14.6771 15.47 14.5301L12 11.0601L8.53005 14.5301C8.23705 14.8231 7.76202 14.8231 7.46902 14.5301C7.17602 14.2371 7.17602 13.762 7.46902 13.469L11.469 9.46902C11.762 9.17602 12.2371 9.17602 12.5301 9.46902L16.5301 13.469C16.8231 13.762 16.8231 14.2371 16.5301 14.5301C16.3841 14.6771 16.192 14.75 16 14.75Z" fill="#25314C" />
                        </svg>
                        : <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 14.75C11.808 14.75 11.616 14.6771 11.47 14.5301L7.46999 10.5301C7.17699 10.2371 7.17699 9.76202 7.46999 9.46902C7.76299 9.17602 8.23803 9.17602 8.53103 9.46902L12.001 12.939L15.471 9.46902C15.764 9.17602 16.239 9.17602 16.532 9.46902C16.825 9.76202 16.825 10.2371 16.532 10.5301L12.532 14.5301C12.384 14.6771 12.192 14.75 12 14.75Z" fill="#25314C" />
                        </svg>}
                </button>
            </div>
        </div>);
};

const Categorys_details = () => {

    const { t } = useTranslation();

    const { ApiBasUrl, ImgBasUrl, totalcart, setTotalCart, setShowLoginPage, SECRET_KEY } = useContext(MyContext);

    const [buttonlist, setButtonList] = useState([]);
    const [selectbutton, setSelectButton] = useState("");
    const [packagelist, setPackageList] = useState([]);
    const [showbottemsheet, setShowBottemSheet] = useState(false);
    const [loading, setLoading] = useState(true);
    const [servicelist, setServiceList] = useState([]);
    const [apiloading, setApiLoading] = useState(false);
    const [apiloading2, setApiLoading2] = useState(false);
    const [addcart, setAddCart] = useState([]);
    const [totalcartprice, setTotalCartPrice] = useState(0);
    const [selectserviceid, setSelectServiceId] = useState("");
    const [serviceprice, setServicePrice] = useState(0);
    const [packagecartitem, setPackageCartItem] = useState([]);
    const [cartitem, setCartItem] = useState([]);
    const [selectoil, setSelectOil] = useState("");
    const [text, setText] = useState("");
    const [tags, setTags] = useState([]);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState("");

    const Navigate = useNavigate();
    const hasReachedBottom = useRef(false);
    const NoMoreDataRef = useRef(true);

    const Categoryid = sessionStorage.getItem("Categoryid");
    const Currency = secureLocalStorage.getItem("currency");

    useEffect(() => {

        const fetchData = async () => {
            try {

                const localCartItem = localStorage.getItem("Cartitem");

                if (localCartItem) {

                    const bytes = CryptoJS.AES.decrypt(localCartItem, SECRET_KEY);
                    const { packagecartitem, cartitem } = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

                    if (packagecartitem.length > 0 || cartitem.length > 0) {
                        const TotalCart = packagecartitem.length + cartitem.length;
                        setTotalCart(TotalCart);
                        setPackageCartItem(packagecartitem || []);
                        setCartItem(cartitem);
                        const totalAddonPrice = cartitem.reduce((sum, item) => sum + item.price, 0);
                        setTotalCartPrice(totalAddonPrice);
                    }
                    const CartId = cartitem.map(item => item.addon_id);
                    setAddCart(CartId);
                }

                const userId = secureLocalStorage.getItem("Userid") || 0;

                const response = await axios.post(`${ApiBasUrl}/subcategorylist.php`, {
                    cat_id: Categoryid,
                    uid: userId
                });

                if (response.data.ResponseCode === "200") {
                    const subcategories = response.data.subcatlist;
                    setButtonList(subcategories);
                    if (subcategories.length >= 1) {
                        setSelectButton(subcategories[0]);
                        HandleFetchData(subcategories[0], 1);
                    }
                }

                setText(response.data.ResponseMsg);
                setLoading(false);

            } catch (error) {
                console.error("Error in subcategorylist.php or localStorage fetch:", error);
            }
        };

        fetchData();
    }, [Categoryid]);


    const HandleFetchData = async (selectedSubcategory, page) => {
        setSelectButton(selectedSubcategory);

        if (page === 1) {
            setApiLoading(true);
        }

        try {

            const userId = secureLocalStorage.getItem("Userid") || 0;
            const selectedCar = secureLocalStorage.getItem("Selectcar");
            const selectedStore = secureLocalStorage.getItem("Store");

            if (selectedCar && selectedStore) {
                var { brand_id, model_id } = JSON.parse(selectedCar);
                var { store_id } = JSON.parse(selectedStore);
            }

            const requestData = {
                uid: userId,
                subcat_id: selectedSubcategory.id,
                brand_id: brand_id || "1",
                model_id: model_id || "1",
                store_id: store_id || "1",
                page: page,
                limit: limit ? limit : "5"
            };

            const response = await axios.post(`${ApiBasUrl}/subcatproduct.php`, requestData);

            setText(response.data.ResponseMsg);

            const { services, limit_per_page, ResponseCode } = response.data;

            if (ResponseCode !== "200") return;

            setLimit(limit_per_page);

            const localCartItem = localStorage.getItem("Cartitem");

            if (localCartItem) {
                const bytes = CryptoJS.AES.decrypt(localCartItem, SECRET_KEY);
                var { packagecartitem } = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            }

            const filteredServices = services.map(service => {
                const cartItem = packagecartitem?.find(item => item.item_type === "service" && item.service_id === service.service_id);
                const isInCart = Boolean(cartItem);
                const totalcart = isInCart && cartItem.totalcart ? cartItem.totalcart : 0;
                return {
                    ...service,
                    totalcart,
                    subcat_id: selectedSubcategory.id
                };
            });

            if (filteredServices.length <= 0) {
                NoMoreDataRef.current = false;
                return;
            }

            if (page === 1) {
                setPackageList(filteredServices);
            } else {
                setPackageList(prev => [...prev, ...filteredServices]);
            }

        } catch (error) {
            console.error("Error fetching subcatproduct.php:", error);
        } finally {
            setApiLoading(false);
            setLoading(false);
        }
    };

    useEffect(() => {
        if (buttonlist.length <= 0) return;

        const handleScroll = () => {
            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
            const clientHeight = window.innerHeight;

            const isAtBottom = scrollTop + clientHeight >= scrollHeight - 100;

            if (isAtBottom && !hasReachedBottom.current && NoMoreDataRef.current) {
                hasReachedBottom.current = true;
                setPage(prev => prev + 1);
            } else if (!isAtBottom && hasReachedBottom.current) {
                hasReachedBottom.current = false;
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        if (page === 1 || !NoMoreDataRef.current) return;
        HandleFetchData(selectbutton, page);
    }, [page])

    const HandleGetService = async (e, service_id, price, isType, isSelected) => {
        e.stopPropagation();
        const Userid = secureLocalStorage.getItem("Userid");

        if (!Userid) {
            setShowLoginPage(true);
            return;
        }

        if (!isType && !isSelected) {
            HandleAddToCart(service_id, 0, "normal");
            return;
        }

        if (isSelected) {
            const resetList = packagelist.map(item => {
                if (item.service_id === service_id) {
                    return { ...item, totalcart: 0 }
                }
                return item;
            });

            setPackageList(resetList);

            const PackageList = packagecartitem.filter(item => {
                return !(item.item_type === "service" && item.service_id === service_id);
            });

            setPackageCartItem(PackageList);
            const CartList = cartitem.filter(item => item.addon_type !== "oil");
            const combinedCartItems = [...CartList, ...PackageList];
            setCartItem(CartList);
            setTotalCart(combinedCartItems.length);
            setSelectOil("");
            setTotalCartPrice(0);
            setServicePrice(0);
            return;
        }

        setShowBottemSheet(true);
        setApiLoading2(true);
        setSelectServiceId(service_id);
        setServicePrice(price);

        const SelectCar = secureLocalStorage.getItem("Selectcar");
        const SelectStore = secureLocalStorage.getItem("Store");

        if (!SelectCar || !SelectStore) return;

        try {
            const { brand_id, model_id } = JSON.parse(SelectCar);
            const { store_id } = JSON.parse(SelectStore);

            const response = await axios.post(`${ApiBasUrl}/get_service_addons.php`, {
                service_id,
                brand_id,
                model_id,
                store_id
            });

            const addons = response.data.addons;
            const isAddOil = addons.filter(item => item.addon_type === "oil");
            setSelectOil(isAddOil[0]);
            setServiceList(addons || []);

        } catch (error) {
            console.error("Error fetching service addons:", error);
        } finally {
            setApiLoading2(false);
        }
    };

    const HandleAddCart = (item, index) => {

        const addon_id = item.addon_id;
        let TotalPrice;

        if (item.addon_type === "oil") {
            setSelectOil(item);
            return;
        }

        if (addcart.includes(addon_id)) {
            const FilterCart = addcart.filter(item => addon_id !== item);
            setAddCart(FilterCart);
            TotalPrice = totalcartprice - item.price;
            setTotalCart(totalcart - 1);
            const Copy = [...cartitem]
            Copy.splice(index, 1);
            setCartItem(Copy);
        } else {
            TotalPrice = totalcartprice + item.price;
            const isAlreadySelected = packagelist.some(item => item.totalcart >= 1);
            setTotalCart(!isAlreadySelected ? 1 : totalcart + 1);
            HandleAddToCart(selectserviceid, 1, "addon");
            setCartItem([...cartitem, item]);
            setAddCart([...addcart, addon_id]);
        }

        setTotalCartPrice(TotalPrice);
    };

    const HandleNavigate = (item) => {
        Navigate("/details");
        secureLocalStorage.setItem("servicedata", JSON.stringify({ title: item.service_title, service_id: item.service_id }));
    }

    const HandleAddToCart = (service_id, index, isType) => {

        if (index !== 1) {
            setShowBottemSheet(false);
        }

        let updatedCartItems = [...packagecartitem];
        let selectedAddon = null;

        const updatedPackageList = packagelist.map(item => {
            const isSelected = item.service_id === service_id;

            if (isType === "addon") {
                if (isSelected) {
                    selectedAddon = {
                        ...item,
                        totalcart: 1,
                        addon_id: selectoil?.addon_id,
                        item_type: 'service'
                    };
                    return selectedAddon;
                } else {
                    if (item.service_type === "addon") {
                        return {
                            ...item,
                            totalcart: 0
                        };
                    }
                }
            }

            if (isType === "normal") {
                if (isSelected) {
                    const updatedItem = {
                        ...item,
                        totalcart: 1,
                        item_type: 'service'
                    };
                    updatedCartItems.push(updatedItem);
                    return updatedItem;
                }
                return item;
            }
            return item;
        });

        const existingAddon = packagecartitem.find(item => item.service_type === "addon");
        const finalAddon = selectedAddon ?? existingAddon;

        const finalCart = updatedCartItems.filter(item => item.service_type !== "addon");

        if (finalAddon) {
            finalCart.push(finalAddon);
        }

        setPackageCartItem(finalCart);
        setPackageList(updatedPackageList);
    };

    useEffect(() => {
        const Data = selectoil ? [...cartitem, selectoil] : [...cartitem];
        const combinedCartItems = { packagecartitem: [...packagecartitem], cartitem: Data };
        const combineLength = [...packagecartitem, ...Data];

        if (combineLength.length > 0) {
            const encrypted = CryptoJS.AES.encrypt(JSON.stringify(combinedCartItems), SECRET_KEY).toString();
            localStorage.setItem('Cartitem', encrypted);
        } else {
            localStorage.removeItem("Cartitem");
        }

        setTotalCart(combineLength.length);
    }, [packagecartitem, cartitem]);

    const HandleSelectSubCategory = (item) => {
        setPage(1);
        setLimit("");
        HandleFetchData(item, 1);
    }

    return (
        <div className="details_page">
            {loading
                ? <div className="w-full h-[100vh] bg-white fixed top-0 flex items-center justify-center">
                    <div className="loader2"></div>
                </div>
                : <div className="width_container">
                    {buttonlist.length >= 1 && <div className="flex justify-center max-_580_:justify-start mt-[20px] overflow-hidden ">
                        <div className="bg-white max-_580_:w-full inline-block rounded-[50px] max-_580_:rounded-[10px] px-[10px] py-[10px]">
                            <div className="flex items-center gap-[20px] whitespace-nowrap scroll-container">
                                {buttonlist.map((item, index) => {
                                    return <button
                                        key={index}
                                        onClick={() => HandleSelectSubCategory(item)}
                                        className={`${selectbutton.id === item.id ? "bg-[#682afb] text-white" : "bg-[#F1F2F4]"} duration-[0.5s] px-[20px] py-[8px] rounded-[50px] font-[500] max-_430_:text-[15px] text-[17px]`} >{item.subcategory_title}</button>
                                })}
                            </div>
                        </div>
                    </div>}

                    <div className="section_details">
                        <h1 className="text-[22px] font-bold">{selectbutton.subcategory_title}</h1>
                        <div className="flex flex-wrap items-center gap-[20px] mt-[20px]">

                            {apiloading
                                ? <div className="w-full h-[400px] flex items-center justify-center">
                                    <div className="loader2"></div>
                                </div>
                                : packagelist?.length >= 1
                                    ? packagelist?.map((item, index) => {
                                        const isSelected = item.totalcart >= 1;

                                        const isType = item.service_type === "addon";

                                        return <div key={index} onClick={() => HandleNavigate(item)} className="packages_box cursor-pointer">
                                            <div className={`${item.service_type === "normal" ? "py-[22px]" : "py-[10px]"} px-[15px]`}>
                                                <div className="flex max-_430_:flex-wrap items-center gap-[10px]">
                                                    <ImgLoad url={ImgBasUrl + item.service_img} Customestyle={"w-[140px] max-_430_:w-full object-cover h-[140px] rounded-[15px]"} />
                                                    <div className="">
                                                        <h1 className="font-[500] text-[20px]">{item.service_title}</h1>
                                                        {item.service_subtitle.split(',').map((item, index) => (
                                                            <p key={index} className="text-gray-600 text-[17px]">• {item.trim()}</p>
                                                        ))}
                                                    </div>
                                                </div>
                                                <div className="mt-[5px] flex max-_430_:flex-col max-_430_:items-start items-center justify-between">
                                                    <div className="flex items-center gap-[5px] text-[15px]">
                                                        <span className="line-through text-gray-500 text-[17px]">{Currency}{item.price}</span>
                                                        <h1 className="font-bold text-[17px]">{Currency}{item.discount_price}</h1>
                                                        <p className="text-green-600 text-[17px]">{item.discount_percentage}% {t("OFF")}</p>
                                                    </div>
                                                    <div className="text-center max-_430_:mt-[10px] max-_430_:w-full max-_430_:flex max-_430_:items-center max-_430_:gap-[10px]">
                                                        <div onClick={(e) => HandleGetService(e, item.service_id, item.discount_price, isType, isSelected)} className='add_button max-_430_:w-full'>
                                                            <h1 className={`py-[2px] px-[20px] ${isSelected && "bg-[#682afb] text-white"} text-[#682afb]`}>{isSelected ? t("ADDED") : t("ADD")}</h1>
                                                        </div>
                                                        {isType && <button disabled={!isSelected} onClick={(e) => HandleGetService(e, item.service_id, item.discount_price, true)} className={`${isSelected ? "text-[#682afb]" : "text-gray-500"} font-[500] text-[14px] max-_430_:w-full`}>{isSelected ? t("Edit") : t("Add Ons")}</button>}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    })
                                    : <div className="w-full h-[400px] flex items-center justify-center">
                                        <div className="text-center">
                                            <img src={ImpyImg} className='w-[300px]' alt="ImpyImg" />
                                            <h1 className='font-[500] text-[20px]'>{text}</h1>
                                        </div>
                                    </div>}
                        </div>
                    </div>
                </div>}

            {showbottemsheet && <div onClick={() => setShowBottemSheet(false)} className="bottem_sheet items-end">
                <div onClick={(e) => e.stopPropagation()} className="bottem_box overflow-hidden">
                    <div className="max-h-[800px] scroll-container">
                        {apiloading2
                            ? <div className="h-[500px] flex items-center justify-center">
                                <div className="loader2"></div>
                            </div>
                            : <div>
                                <div className="">
                                    <div className="text-center leading-[20px] bg-[#F1F2F4] py-[15px]">
                                        <h1 className="text-[19px] font-bold">{t("Basic Service")}</h1>
                                        <p className="font-[500] text-gray-500">{t("Select Engine oil")}</p>
                                    </div>
                                    <div className="flex items-center gap-[10px] px-[15px] py-[10px] scroll-container">
                                        {servicelist.map((item, index) => {
                                            if (item.addon_type === "oil") {
                                                return (<div key={index} onClick={() => HandleAddCart(item, index)} className={`min-w-[50%] max-w-[50%] duration-[0.5s] ${selectoil.addon_id === item.addon_id && "border-[#682afb]"} border-[2px] rounded-[10px] cursor-pointer`}>
                                                    <div className="p-[10px]">
                                                        <h1 className='font-[500] text-[16px] mb-[10px]'>{item.title}</h1>
                                                        <ImgLoad url={ImgBasUrl + item.img} Customestyle={"w-[50px] h-[50px] object-contain"} />
                                                        <p className='text-[15px]'>{item.subtitle.slice(0, 50)}</p>
                                                    </div>

                                                    <div className="border-t-[1px] "></div>

                                                    <div className="px-[10px] py-[5px] flex items-center gap-[10px] justify-between">
                                                        <h1 className='font-bold text-[15px] text-gray-700'>{item.price === 0 ? t("Free") : `${Currency}${item.price}`}</h1>
                                                        <div className={`w-[18px] h-[18px] duration-[0.5s] border-[2px] overflow-hidden p-[2px] rounded-full ${selectoil.addon_id === item.addon_id && "border-[#682afb]"}`}>
                                                            <div className={`w-full h-full duration-[0.5s] rounded-full ${selectoil.addon_id === item.addon_id && "bg-[#682afb]"}`}></div>
                                                        </div>
                                                    </div>
                                                </div>)
                                            }
                                        })}
                                    </div>
                                </div>
                                <div className="">
                                    <div className="text-center leading-[20px] bg-[#F1F2F4] py-[15px]">
                                        <h1 className="text-[19px] font-bold">{t("Boost Your Service")}</h1>
                                        <p className="font-[500] text-gray-500">{t("For better performance & mileage")}</p>
                                    </div>
                                    <div className="px-[15px] py-[10px]">
                                        {servicelist.map((item, index) => {
                                            if (item.addon_type === "normal") {
                                                return <ServiceItemNormal key={index} index={index} item={item} Currency={Currency} ImgBasUrl={ImgBasUrl} HandleAddCart={HandleAddCart} AddCartData={addcart} />
                                            }

                                        })}
                                    </div>
                                </div>
                            </div>}
                    </div>
                    {!apiloading2 && <div className="bg-[#682afb] px-[15px] py-[10px]">
                        <div className="flex items-center justify-between text-white">
                            <h1 className="font-bold ">{Currency}{!apiloading2 ? totalcartprice + serviceprice + selectoil?.price : 0}</h1>
                            <button onClick={() => HandleAddToCart(selectserviceid, 0, "addon")} className="font-[500]">{t("ADD TO CART")}</button>
                        </div>
                    </div>}
                </div>
            </div>}

            {tags.length >= 1 && <div onClick={() => setTags([])} className="bottem_sheet items-center">
                <div onClick={(e) => e.stopPropagation()} className="bg-white py-[10px] px-[15px] rounded-[10px] max-w-[25%]">
                    {tags.map((item, index) => {
                        return <div key={index} className="flex items-center gap-[10px] mt-[5px]">
                            <div className="bg-green-500 rounded-[500px]">
                                <svg width="17" height="17" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9 17.75C8.999 17.75 8.99799 17.75 8.99699 17.75C8.79699 17.749 8.60599 17.669 8.46499 17.526L4.46499 13.464C4.17399 13.169 4.178 12.694 4.473 12.403C4.768 12.113 5.24399 12.116 5.53399 12.411L9.003 15.935L18.469 6.46902C18.762 6.17602 19.237 6.17602 19.53 6.46902C19.823 6.76202 19.823 7.23705 19.53 7.53005L9.53 17.5301C9.39 17.6711 9.199 17.75 9 17.75Z" fill="white" />
                                </svg>
                            </div>
                            <h1 className=''>{item}</h1>
                        </div>
                    })}
                </div>
            </div>}

            {totalcart !== 0 && <div className="fixed bottom-[10px] left-0 right-0">
                <div className="flex items-center justify-center cursor-pointer">
                    <div className="bg-[#682afb] py-[8px] px-[15px] inline-block rounded-[50px]">
                        <button onClick={() => Navigate("/cart", { state: { title: "Category Details", path: "/category-details" } })} className="flex items-center">
                            <div className="text-white flex items-center gap-[10px]">
                                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10 21C10 21.552 9.55501 22 9.005 22C8.45701 22 8 21.552 8 21C8 20.448 8.43499 20 8.98499 20H9.005C9.55501 20 10 20.448 10 21ZM17.005 20H16.985C16.435 20 16 20.448 16 21C16 21.552 16.457 22 17.005 22C17.555 22 18 21.552 18 21C18 20.448 17.555 20 17.005 20ZM21.459 8.44701L20.444 14.617C20.185 16.046 19.574 17.499 17 17.499H8.73401C7.49801 17.499 6.43403 16.576 6.25903 15.353L4.74902 4.78799C4.64502 4.05399 4.00601 3.5 3.26501 3.5H3C2.724 3.5 2.5 3.276 2.5 3C2.5 2.724 2.724 2.5 3 2.5H3.26599C4.50199 2.5 5.56597 3.423 5.74097 4.646L5.86304 5.5H19C19.744 5.5 20.443 5.82699 20.92 6.39799C21.396 6.969 21.592 7.71601 21.459 8.44701ZM19.615 13.5H13C12.724 13.5 12.5 13.276 12.5 13C12.5 12.724 12.724 12.5 13 12.5H19.7791L20.473 8.276C20.554 7.829 20.436 7.381 20.151 7.039C19.865 6.696 19.445 6.5 18.999 6.5H6.005L7.25 15.212C7.354 15.946 7.99301 16.5 8.73401 16.5H17C18.754 16.5 19.218 15.778 19.459 14.447L19.615 13.5Z" fill="white" />
                                </svg>
                                <div className="text-center leading-[18px]">
                                    <h1>{totalcart} {t("Service Added")}</h1>
                                    <h1 className='font-[500]'>{t("VIEW CART")}</h1>
                                </div>
                            </div>
                            <svg className='ms-[10px]' width="16" height="20" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.35401 5.35401L1.35401 9.35401C1.25601 9.45201 1.12801 9.50001 1.00001 9.50001C0.87201 9.50001 0.744006 9.45101 0.646006 9.35401C0.451006 9.15901 0.451006 8.84198 0.646006 8.64698L4.292 5.00099L0.646006 1.35499C0.451006 1.15999 0.451006 0.842959 0.646006 0.647959C0.841006 0.452959 1.15804 0.452959 1.35304 0.647959L5.35304 4.64796C5.54904 4.84196 5.54901 5.15801 5.35401 5.35401Z" fill="white" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>}
        </div>
    )
}

export default Categorys_details;
/* jshint ignore:end */

export const ImgLoad = ({ url, Customestyle }) => {

    const [imgLoaded, setImgLoaded] = useState(false);

    return (<>
        <img
            src={url}
            alt="Model"
            onLoad={() => setImgLoaded(true)}
            onError={() => setImgLoaded(true)}
            className={`${Customestyle} transition-opacity duration-300 ${imgLoaded ? "opacity-100" : "opacity-0"}`}
        />
    </>
    )
}